<script setup lang="ts">
defineProps<{ label: string }>();
</script>

<template>
  <div
    class="grid grid-cols-[92px_1fr] items-center py-1 text-[12px] leading-[1.45]"
  >
    <dt class="text-encre-douce">{{ label }}</dt>
    <dd class="font-semibold"><slot /></dd>
  </div>
</template>
